module.exports = __webpack_public_path__ + "img/main_logo.b0e02e54.png";